import React, { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';

import ComponentIterator from '../../../containers/ComponentIterator';
import imageModifier from '../helpers/imageModifier';
import RoutesContext from '../../../context/routesContext';
import getLocalization from '../../../util/localization';
import translateObj from '../../../util/translateObj';
import PSResponsiveUtility from '../LineUp/PSResponsiveUtility';


const SliderBannerTickets = ({
  image,
  left,
  right,
  match,
  single,
  areSlidesShort,
  noZoom = false,
  noShadow = false,
  showOpacity,
  dropDownItems,
  isFooterSlider,
}) => {
  const [deviceWidth, setDeviceWidth] = useState('lg');

  const responsiveUtility = useRef();

  const setLayout = (x) => {
    x.map(component => {
      if (areSlidesShort && !isFooterSlider) {
        component.layout = "tickets"
      }
    });
  };
  const setMargin = (x) => {
    x.map(component => component.slider = true);
  };
  
  const getWidth = () => {
    // actions when window is resized
    setDeviceWidth(responsiveUtility.current.deviceScreen(true));
  };

  useEffect(() => {
    //const linkButton = left.find(el => el.type === 'LinkButtonRounded');
    getWidth();
  }, []);
  return (
    <RoutesContext.Consumer>
      {({ language: contextLanguage, enteredFrom }) => {
        const localization = getLocalization(contextLanguage, enteredFrom, match);
        let imageurl = `url(${imageModifier(translateObj(image, localization.language), '1440x620')})`;
        if (deviceWidth === 'sm') imageurl = `url(${imageModifier(translateObj(image, localization.language), '414x420')})`;
        if (deviceWidth === 'md') imageurl = `url(${imageModifier(translateObj(image, localization.language), '768x510')})`;
        const backgroundStyle = {
          backgroundImage: imageurl,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        };
        return (
          <>
            <PSResponsiveUtility ref={responsiveUtility} deviceWidthCallback={getWidth} />
            <div
              key={image.en}
              className={`${!areSlidesShort ? 'h-screen80' : 'h-screen40'} ${showOpacity ? 'sliderComponent' : ''} md:h-carouselMD sm:h-carouselSM w-full relative flex flex-col justify-end overflow-hidden min-h-screen40`}
            >
              <div
                key={image.en}
                className={`${!areSlidesShort ? 'h-screen80' : 'h-screen40'} md:h-carouselMD sm:h-carouselSM w-full backgroundImgGray ${!noZoom && 'sliderBackground'} absolute pin-l pin-b`}
                style={backgroundStyle}
              />
              <div className="text-white flex items-end h-full relative" style={{ zIndex: 2 }}>
                <div className={`${areSlidesShort && !isFooterSlider ? "justify-start" : "justify-around"} flex sm:flex-col sm:justify-end w-full xl:px-36 md:px-16 lg:px-26 sm:px-7 h-full items-end ${areSlidesShort ? 'pb-12' : 'pb-20'} sm:pb-13 md:pb-16`}>
                  {deviceWidth !== 'sm'
                    ? (
                      <>
                        {left && (
                          <div className="w-2/3 h-full flex flex-col justify-end mr-12 sm:mr-0 sm:hidden max-w-lg">
                            <div className="div">
                              <ComponentIterator components={left} slugName={image} {...setMargin(left)} {...setLayout(left)}/>
                            </div>
                          </div>
                        )}
                        <div className={`${areSlidesShort && !isFooterSlider ? "hidden sm:hidden" : "flex"} pt-7 pb-16 font-americaMonoRegular relative flex-col`}>
                          {dropDownItems.length > 0 && dropDownItems.map(item => (
                            <div className='py-2'>
                              <span><a href={item.link} className="text-white">{item.label}</a></span>
                            </div>
                          ))}
                        </div>
                      </>
                    )
                    : (
                      <>
                        {left && (
                        <div className="w-full sm:block hidden">
                          <ComponentIterator components={left} slugName={image} />
                        </div>
                        )}
                        <div className={`${areSlidesShort && !isFooterSlider ? "hidden sm:hidden" : ""} pt-7 pb-16 px-7 bg-black w-full font-white font-americaMonoRegular font-bold fixed pin-b pin-l flex flex-col`}>
                          {dropDownItems.length > 0 && dropDownItems.map(item => (
                            <div className="w-full py-2">
                              <span><a href={item.link} className="text-white">{item.label}</a></span>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </>
        );
      }
      }
    </RoutesContext.Consumer>
  );
};

SliderBannerTickets.propTypes = {
  image: PropTypes.shape({}),
  right: PropTypes.arrayOf(PropTypes.shape()),
  left: PropTypes.arrayOf(PropTypes.shape()),
  single: PropTypes.bool,
  areSlidesShort: PropTypes.bool,
  showOpacity: PropTypes.bool,
  isFooterSlider: PropTypes.bool,
};

SliderBannerTickets.defaultProps = {
  right: null,
  left: null,
  image: {},
  single: true,
  areSlidesShort: false,
  showOpacity: true,
  isFooterSlider: false
};

export default withRouter(SliderBannerTickets);
